// AI Generated Component
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { TranslateService } from '@client/app/services/translate/translate.service';

@Component({
    selector: 'filter-button',
    templateUrl: './filter-button.component.html',
    standalone: false,
})
export class FilterButtonComponent {
    @Input() showFiltersBtn?: boolean;
    @Input() isFiltersOpen?: boolean;
    @Output() isFiltersOpenChange = new EventEmitter<boolean>();

    constructor (private translateService: TranslateService) {}

    toggleShowFilters (): void {
        this.isFiltersOpen = !this.isFiltersOpen;
        this.isFiltersOpenChange.emit(this.isFiltersOpen);
    }

    getFiltersTranslation (): string {
        if (Boolean(this.isFiltersOpen)) {
            return this.translateService.getString('Close filters');
        } else {
            return this.translateService.getString('Open filters');
        }
    }
}
